export default __webpack_public_path__ + "static/media/rearguard.128f2e0c.png";